/**
 * The initial/default values the used-search-options vuex store uses for userOptions
 */
export default function() {
    return {
        searchType:'Used Cars',
        d: '',
        paymentSearch: 0,
        stockSearchPaymentSearch: 0,
        minPayment: 0,
        maxPayment: 2000,
        deposit: 2315,
        term: 48,
        annualMileage: 10000,
        distance: -1,
        manufacturer: [],
        model: [],
        trim: '',
        minPrice: 0,
        maxPrice: 0,
        photo: 'N',
        sortBy: 'recommended',
        stockSearchSortBy: 'recommended',
        page: 1,
        pageSize: 12,
        approvedUsedOffer: 0,
        specialOffer: 0,
        new: 0
    };
}